(function($, _window, _body) {
	_window.on('elementor/frontend/init', function() {
		elementorFrontend.hooks.addAction('frontend/element_ready/theme-faq-archive.default', function($scope, $s) {
			var wrapper = $('.faq-archive-wrap', $scope);
			var filterWrap = $('.item-filters', wrapper);
			var itemsWrap = $('.item-grid', wrapper);
			var filterEl = filterWrap.find('a');
			var setting = JSON.parse($('.theme-widget-element', $scope)
				.attr('data-setting'));
			var appliedFilter = $.extend({}, {
				page: 1,
				category: '',
			}, setting.activeFilter);
			var currentPage = 1;
			var maxPages = 1;
			var done = true;
			var tpl = _.template($('#theme-faq-archive-tpl')
				.html());
			var setUrl = function(url) {
				if (window.history && window.history.pushState) {
					window.history.pushState({}, '', url);
				}
			};
			var applyFilters = function() {
				var newUrl = setting.base;
				if (appliedFilter.category != '' && appliedFilter.category != setting.default_category) {
					newUrl = setting.base + '?category=' + appliedFilter.category;
				}
				setUrl(newUrl);
				fetchItems();
			};
			var loader = $('<div>')
				.addClass('theme-ajax-loader')
				.append($('<div>')
					.addClass('inner'));
			var fetchItems = function() {
				if (done) {
					done = false;
					var _url = setting.rest;
					wrapper.append(loader);
					$.getJSON(_url, appliedFilter, function(data) {
						var html = $(tpl(data));
						currentPage = data.pagination.currentPage;
						maxPages = data.pagination.maxPages;
						itemsWrap.append(html);
						done = true;
						loader.remove();
					});
				}
			};
			filterEl.on('click', function(e) {
				e.preventDefault();
				var __this = $(this);
				var _filter = __this.attr('data-slug');
				filterEl.removeClass('active');
				__this.addClass('active');
				appliedFilter.page = currentPage = 1;
				appliedFilter.category = '';
				if (_filter) {
					appliedFilter.category = _filter;
				}
				itemsWrap.empty();
				$(this)
					.closest('.item-filters')
					.removeClass('dropdown-active');
									$(this).closest('.item-filters').find('.dropdown-label .label-text').html(__this.html());

				applyFilters();
			});
			itemsWrap.on('click', '.accordion-toggle', function(e) {
				e.preventDefault();
				var __parentItem = $(this)
					.closest('.item');
				var _fa = $(this)
					.find('i.fa');
				__parentItem.siblings('.item')
					.removeClass('active');
				if (__parentItem.hasClass('active')) {
					__parentItem.removeClass('active');
					_fa.removeClass('fa-chevron-up')
						.addClass('fa-chevron-down');
				} else {
					_fa.removeClass('fa-chevron-down')
						.addClass('fa-chevron-up');
					__parentItem.addClass('active');
				}
			});
			appliedFilter.page = 1;
			$('.item-filters .dropdown-label', $scope)
				.on('click', function(e) {
					var _parent = $(this)
						.closest('.item-filters');
					_parent.toggleClass('dropdown-active');
					var _fa=$(this).find('i.fa');
					if(_parent.hasClass('dropdown-active')){
						_fa.removeClass('fa-chevron-down').addClass('fa-chevron-up');
					}else{
						_fa.removeClass('fa-chevron-up').addClass('fa-chevron-down');

					}
				});
			_body.on('click', function(e) {
				if (!$('.dropdown-label', $scope)
					.is(e.target) && $('.dropdown-label', $scope)
					.has(e.target)
					.length == 0) {
					$('.item-filters', $scope)
						.removeClass('dropdown-active');
					$('.item-filters .dropdown-label i.fa', $scope)
						.removeClass('fa-chevron-up')
						.addClass('fa-chevron-down');
				}
			});
			appliedFilter.page = 1;
			filterWrap.find("a[data-slug='" + setting.default_category + "']")
				.attr('href', setting.base)
				.trigger('click');
		});
	});
})(jQuery, jQuery(window), jQuery('body'));